/* Searchanise results page -- behaviour the stylesheet cannot do alone
 * Task: https://app.clickup.com/t/86d3x6j51
 *
 * Pairs with assets/searchanise-results.css. Four jobs (the third, the
 * phone tab row keeping its scroll place, and the fourth, Sort By opening on
 * click only, are described at sections 3 and 4):
 *
 *   1. Sharper Collections thumbnails. The card grid is three times wider than
 *      the 160px "_compact" image the widget asks for; request a 600px copy.
 *
 *   2. The phone filter drawer. The widget's own panel opens one filter group
 *      at a time behind a list of names. The mockup shows every group at once
 *      in a drawer from the left, the way the collection page does. The CSS
 *      lays the groups out; this adds what a layout cannot:
 *        - a group heading collapses and expands its options
 *        - the chosen filters appear as tags at the top, each one removable
 *
 * Every change is keyed to the widget's markup and re-applied after each
 * redraw (ticking a box redraws the whole panel), so a group the shopper
 * collapsed is remembered here, not in the DOM.
 */
(function () {
    'use strict';

    /* ----------------------------------------------------------------------
       1. Collections thumbnails
       ---------------------------------------------------------------------- */

    var IMAGE_SELECTOR = '#snize_results .snize-search-results-categories li.snize-category img';
    var SIZE_SUFFIX = /_(pico|icon|thumb|small|compact|medium|large|grande|\d+x\d*|x\d+)(\.[a-z]+)(\?|$)/i;
    var TARGET_SIZE = '_600x';

    function upgradeImages() {
        document.querySelectorAll(IMAGE_SELECTOR).forEach(function (img) {
            var src = img.getAttribute('src') || '';
            if (src.indexOf('cdn.shopify.com') === -1) return;
            var next = src.replace(SIZE_SUFFIX, TARGET_SIZE + '$2$3');
            /* An already-upgraded src rewrites to itself, so the attribute
               mutation this causes settles on the next pass. */
            if (next !== src) img.setAttribute('src', next);
        });
    }

    /* ----------------------------------------------------------------------
       2. Phone filter drawer
       ---------------------------------------------------------------------- */

    var DIALOG_ID = 'snize-modal-mobile-filters-dialog';
    var GROUP_HEADER =
        '.snize-product-filters-header:not(#snize_filters_block_header):not(#snize_product_filter_header_sort_by)';
    var collapsed = Object.create(null); // header id → true

    function syncGroups(dialog) {
        dialog.querySelectorAll(GROUP_HEADER).forEach(function (header) {
            var isCollapsed = !!collapsed[header.id];
            if (header.classList.contains('sxr-collapsed') !== isCollapsed) {
                header.classList.toggle('sxr-collapsed', isCollapsed);
            }
            var aria = String(!isCollapsed);
            if (header.getAttribute('aria-expanded') !== aria) header.setAttribute('aria-expanded', aria);
            /* The app gives the heading a button role on some loads and not on
               others (seen 10/05), and aria-expanded on a plain div is an axe
               error. It opens and closes on Enter/Space below, so it is a button. */
            if (header.getAttribute('role') !== 'button') header.setAttribute('role', 'button');
            if (header.getAttribute('tabindex') !== '0') header.setAttribute('tabindex', '0');
        });
    }

    /* The option's visible name, without its count. Not the input's
       data-se-facet-value-title: the app writes that attribute unescaped, so a
       size like 2" x 3" arrives cut off at the first inch mark. */
    function optionLabel(input) {
        var label = input.closest('label');
        var text = label && label.querySelector('span.needsclick:not(:empty)');
        var name = '';
        if (text) {
            text.childNodes.forEach(function (node) {
                if (node.nodeType === 3) name += node.textContent;
            });
        }
        return name.trim() || input.value;
    }

    function syncTags(dialog) {
        var content = dialog.querySelector('.snize-modal-content');
        var header = document.getElementById('snize_filters_block_header');
        if (!content || !header) return;

        var checked = Array.prototype.slice.call(
            dialog.querySelectorAll('.snize-product-filter-container input.snize-product-filters-checkbox:checked'),
        );
        var signature = checked
            .map(function (input) { return input.name + '=' + input.value; })
            .join('|');

        var bar = content.querySelector('.sxr-drawer-tags');
        if (!checked.length) {
            if (bar) bar.remove();
            return;
        }
        if (!bar) {
            bar = document.createElement('div');
            bar.className = 'sxr-drawer-tags';
            header.after(bar);
        }
        if (bar.dataset.signature === signature) return;
        bar.dataset.signature = signature;

        bar.innerHTML = '';
        checked.forEach(function (input) {
            var label = optionLabel(input);
            var tag = document.createElement('button');
            tag.type = 'button';
            tag.className = 'sxr-drawer-tag';
            tag.dataset.name = input.name;
            tag.dataset.value = input.value;
            tag.setAttribute('aria-label', 'Remove filter ' + label);
            tag.textContent = label;
            bar.appendChild(tag);
        });
    }

    function syncDrawer() {
        var dialog = document.getElementById(DIALOG_ID);
        if (!dialog) return;
        syncGroups(dialog);
        syncTags(dialog);
    }

    function toggleGroup(header) {
        collapsed[header.id] = !collapsed[header.id];
        syncDrawer();
    }

    /* Capture phase, so the widget never sees a heading click: in its own
       layout a heading is the way back to the list of groups, which the
       drawer no longer has. */
    document.addEventListener(
        'click',
        function (event) {
            var target = event.target;
            if (!target.closest || !target.closest('#' + DIALOG_ID)) return;

            var header = target.closest(GROUP_HEADER);
            if (header) {
                event.preventDefault();
                event.stopPropagation();
                toggleGroup(header);
                return;
            }

            var tag = target.closest('.sxr-drawer-tag');
            if (tag) {
                var dialog = document.getElementById(DIALOG_ID);
                var inputs = dialog.querySelectorAll('input.snize-product-filters-checkbox:checked');
                for (var i = 0; i < inputs.length; i++) {
                    if (inputs[i].name === tag.dataset.name && inputs[i].value === tag.dataset.value) {
                        inputs[i].click();
                        break;
                    }
                }
            }
        },
        true,
    );

    document.addEventListener(
        'keydown',
        function (event) {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            var header = event.target.closest && event.target.closest('#' + DIALOG_ID + ' ' + GROUP_HEADER);
            if (!header) return;
            event.preventDefault();
            event.stopPropagation();
            toggleGroup(header);
        },
        true,
    );

    /* ----------------------------------------------------------------------
       3. Phone tab row keeps its place
       "When a user selects a tab, the tab container should automatically
       scroll the active tab fully into view ... It should not reset back to
       the far-left position after the page updates" (Jossa, 09/18). The
       widget redraws the whole row on every tab switch, and a new row starts
       scrolled to the left, so the position is kept here and put back.
       ---------------------------------------------------------------------- */

    var TAB_ROW = '#snize_results.snize-mobile-design .snize-main-panel-controls';
    var EDGE = 16; // room left beside a revealed tab, so it doesn't sit flush
    var tabRow = null;
    var tabScroll = 0;
    var activeTab = '';

    function currentTab(row) {
        // In classes view the widget still marks its own tab; ours wins.
        return row.querySelector('a.sxr-classes-tab.active') || row.querySelector('a.active');
    }

    function reveal(row, tab) {
        var r = row.getBoundingClientRect();
        var t = tab.getBoundingClientRect();
        if (t.left < r.left) row.scrollLeft -= r.left - t.left + EDGE;
        else if (t.right > r.right) row.scrollLeft += t.right - r.right + EDGE;
        tabScroll = row.scrollLeft;
    }

    function syncTabRow() {
        var row = document.querySelector(TAB_ROW);
        if (!row) return;

        if (row !== tabRow) {
            tabRow = row;
            row.scrollLeft = tabScroll;
            row.addEventListener(
                'scroll',
                function () {
                    if (row === tabRow) tabScroll = row.scrollLeft;
                },
                { passive: true },
            );
        }

        /* The Classes tab is added to a fresh row a moment after the widget
           draws it, pushing the tabs after it along, so a change in how many
           tabs show counts as a change too. */
        var tab = currentTab(row);
        var key = tab ? tab.textContent + '|' + row.querySelectorAll('li:not([hidden])').length : '';
        if (tab && key !== activeTab) reveal(row, tab);
        activeTab = key;
    }

    /* The Classes tab switches without a redraw, only a class change, which
       the observer below does not watch. */
    document.addEventListener('click', function (event) {
        if (event.target.closest && event.target.closest(TAB_ROW + ' a')) {
            window.setTimeout(queue, 50);
        }
    });

    window.addEventListener('popstate', function () {
        window.setTimeout(queue, 50);
    });

    /* ----------------------------------------------------------------------
       4. Sort By opens on click, not hover
       "Could we change this so the dropdown menu only expands on click
       instead of on hover? Like how our collection's sort button works"
       (Jossa, 09/25, https://app.clickup.com/t/86d3x6jdd). On a computer the
       widget opens the list on mouseenter and shuts it on mouseleave, with no
       setting to turn that off. Both are jQuery delegates, which run off the
       native mouseover/mouseout bubbling up, so stopping those two at the
       document in the capture phase leaves only the widget's own click and
       keyboard toggle. Clicking anywhere else closes the list.
       ---------------------------------------------------------------------- */

    var SORT = '#snize_results .snize-main-panel-dropdown';

    function blockHover(event) {
        if (event.target.closest && event.target.closest(SORT)) event.stopPropagation();
    }

    document.addEventListener('mouseover', blockHover, true);
    document.addEventListener('mouseout', blockHover, true);

    document.addEventListener('click', function (event) {
        if (event.target.closest && event.target.closest(SORT)) return;
        var button = document.querySelector(SORT + ' .snize-main-panel-dropdown-button[aria-expanded="true"]');
        if (!button) return;
        var list = document.querySelector(SORT + ' .snize-main-panel-dropdown-content');
        if (list) list.style.display = 'none';
        button.setAttribute('aria-expanded', 'false');
    });

    /* ----------------------------------------------------------------------
       5. Wishlist heart is a button
       The Wishlist Engine app draws the heart on each card as a <div> with an
       aria-label: a name on something with no role (WCAG 4.1.2, flagged by
       axe), and Tab never reaches it. Giving it a button role, a tab stop and
       Enter/Space makes it one; the app's own click handler does the rest.
       Task: https://app.clickup.com/t/14zcqntjpxg
       ---------------------------------------------------------------------- */

    var HEART = '#snize_results .wishlist-engine';

    function syncHearts() {
        var hearts = document.querySelectorAll(HEART);
        for (var i = 0; i < hearts.length; i++) {
            var heart = hearts[i];
            if (heart.getAttribute('role') !== 'button') heart.setAttribute('role', 'button');
            if (heart.getAttribute('tabindex') !== '0') heart.setAttribute('tabindex', '0');
            var pressed = heart.getAttribute('data-added') === 'true' ? 'true' : 'false';
            if (heart.getAttribute('aria-pressed') !== pressed) heart.setAttribute('aria-pressed', pressed);
        }
    }

    document.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        var heart = event.target.closest && event.target.closest(HEART);
        if (!heart || heart !== event.target) return;
        event.preventDefault();
        (heart.querySelector('.wishlist-engine-button') || heart).click();
    });

    /* ----------------------------------------------------------------------
       6. Product cards read like the collection card
       "Could we use the same Product Cards format and styling that we already
       have on the Collections Page here as well?" and "Can we display the
       badge beside the price?" (Jossa, 10/08). The app prints the saving as
       "Save 12%" below the price list and "1 review(s)" by the stars; the
       collection card says "12% off" inside the price line and "1 review".
       The CSS hides the old badge on the photo and styles these.
       Task: https://app.clickup.com/t/14zcqntjpxg
       ---------------------------------------------------------------------- */

    var CARD = '#snize_results li.snize-product';
    var SAVE_PERCENT = /(\d+(?:\.\d+)?%)/;
    var REVIEW_COUNT = /^\s*(\d[\d,]*)\s*review/i;

    function syncCards() {
        var cards = document.querySelectorAll(CARD);
        for (var i = 0; i < cards.length; i++) {
            var card = cards[i];

            /* Price list and badge go in a row of our own. Not inside the
               price list: the app rewrites that after converting currencies,
               which would delete the badge. The app draws the card two ways
               (seen 10/09): one prints "Save 12%" after the price list, the
               other leaves it out. Both carry it on the photo label, so the
               badge is made from that when the other is missing. */
            var prices = card.querySelector('.snize-price-list');
            var saving = card.querySelector('.snize-price-difference');
            var photoLabel = card.querySelector('.snize-product-discount-label');
            var percent = (saving || photoLabel) && (saving || photoLabel).textContent.match(SAVE_PERCENT);
            if (prices && percent) {
                var line = prices.parentNode.classList.contains('sxr-price-line') ? prices.parentNode : null;
                if (!line) {
                    line = document.createElement('div');
                    line.className = 'sxr-price-line';
                    prices.before(line);
                    line.appendChild(prices);
                }
                if (!saving) {
                    saving = document.createElement('span');
                    saving.className = 'snize-price-difference';
                }
                if (saving.parentNode !== line) line.appendChild(saving);
                var label = percent[1] + ' off';
                if (saving.textContent !== label) saving.textContent = label;
            }

            /* "4 reviews" on a computer; the CSS leaves only "4" on phones,
               as the collection card does. */
            var total = card.querySelector('.snize-reviews .total-reviews');
            if (total && !total.querySelector('.sxr-reviews-word')) {
                var count = total.textContent.match(REVIEW_COUNT);
                if (count) {
                    var word = document.createElement('span');
                    word.className = 'sxr-reviews-word';
                    word.textContent = count[1] === '1' ? ' review' : ' reviews';
                    total.textContent = count[1];
                    total.appendChild(word);
                }
            }

            syncViewOptions(card);
        }
    }

    /* "For products with multiple variations, can we change the CTA to 'View
       Options,' similar to the collection page? The dropdown on these cards
       currently creates a large gap on the neighboring products" (Jossa,
       10/13). A card the app gives an options dropdown gets the collection
       card's View Options button instead, which opens the product page; the
       CSS hides the dropdown. Retired cards keep their vote button.
       When the first option can't be bought the app prints "View product"
       instead of Add to Bag; on an in-stock card that is the same choice of
       options, so it gets View Options too. Sold-out cards keep theirs. */
    function syncViewOptions(card) {
        if (card.classList.contains('retired-search-card')) return;
        if (!card.querySelector('.snize-options-box select')) return;
        card.classList.add('sxr-has-options');

        var old = card.querySelector('.snize-buttons .snize-add-to-cart-button');
        if (!old && !card.classList.contains('snize-product-out-of-stock')) {
            old = card.querySelector('.snize-buttons .snize-view-product-button');
        }
        var link = card.querySelector('a.snize-view-link');
        if (!old || !link) return;

        var btn = document.createElement('button');
        btn.type = 'button';
        /* The app's own button classes keep its place and shape; without
           snize-add-to-cart-button the app no longer adds it to the bag. */
        btn.className = old.className + ' sxr-view-options';
        btn.classList.remove('snize-add-to-cart-button', 'snize-view-product-button');
        btn.textContent = 'View Options';
        /* The button sits inside the card's link, which a button does not
           follow on its own. */
        btn.addEventListener('click', function (event) {
            event.preventDefault();
            window.location.href = link.href;
        });
        old.replaceWith(btn);
    }

    /* ----------------------------------------------------------------------
       Boot
       ---------------------------------------------------------------------- */

    var queued = false;

    function run() {
        queued = false;
        upgradeImages();
        syncDrawer();
        syncTabRow();
        syncHearts();
        syncCards();
    }

    function queue() {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(run);
    }

    /* Watched from <body>: an observer attached to #snize_results on load
       never saw the rows arrive, and the filter panel is its own <body> child.
       A changed src wakes this up too in case a source is set after the row is
       inserted, and a changed data-added keeps the heart's pressed state. Batched to one pass per frame. */
    function boot() {
        new MutationObserver(queue).observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['src', 'data-added'],
        });
        queue();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }
})();
